<div class="d-flex justify-content-between">
   <!-- <div class="nav nav-tabs" id="custom-tabs-four-tab" role="tablist">
        <a class="nav-link py-1 active" [class.active]="tab==1" (click)="tab=1"  >
            <i class="fas fa-th-large mr-2"></i>Riepilogo</a>
        <a class="nav-link py-1 active" [class.active]="tab==2" (click)="tab=2"  >
            <i class="fas fa-list mr-2"></i>Lista</a>  
    </div> -->
    <button *ngIf="tab==1" (click)="openDetail()" class="btn btn-success btn-xs m-1"><i class="fas fa-plus mr-2"></i>Nuova pratica</button>
</div>

<div class="tab-content" id="custom-tabs-four-tabContent">
    
    <!-- Riepilogo -->            
    <div *ngIf="tab==1" class="tab-pane active">
        <div *ngIf="!list || list.length==0" class="m-5 text-center text-secondary">
            <i class="icon fas fa-info-circle mr-2"></i>
            <i>Nessun elemento da visualizzare!</i>
        </div>
        <div class="row p-2" style="min-height: 15rem">
            <div class="col-lg-{{cols}}" *ngFor="let o of overviews" >
                <div class="card elevation-0 border-0 height-fixed" [style.background-color]="o.overview.color">
                    <div class="card-body">
                        <h6>{{o.overview.name}}</h6>
                        <small>
                            <p>{{o.overview.description}}</p>
                        </small>
                        <small>
                            <table class="table table-sm">
                                <thead>
                                    <th *ngFor="let h of getKeys(o.data[0])">
                                        {{h}}
                                    </th>
                                </thead>
                                <tr *ngFor="let d of o.data">
                                    <td *ngFor="let h of getKeys(d)">
                                        {{d[h]}}
                                    </td>
                                </tr>
                            </table>
                        </small>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <!-- Lista -->
    <div *ngIf="tab==2" class="tab-pane active" >
        <app-windowlist [model]="this">
            <div class="row">
                <div class="col-lg-2 pr-lg-0" *ngIf="filterbox">
            <div class="d-none d-lg-block w-100 text-center text-primary">Filtri</div>
                    <app-filtercontainer [title]="'Filtra per tipologia o date'" >
                        <app-filterdate [date_type]="100" [class]="'card p-1'" [filter_date]="filter_date" (onSelect)="updateList()"></app-filterdate>
                        <ul  class="small-box list-group card p-1 mt-2">
                            <li class="list-group-item pointer" [class.active]="filter_id_type.value==0" (click)="filter_id_type.value=0;updateList()">Tutte le tipologie</li>
                            <li class="list-group-item pointer" *ngFor="let t of types" [class.active]="filter_id_type.value==t.id" (click)="filter_id_type.value=t.id;updateList()">{{t.name}}</li>
                        </ul>
                    </app-filtercontainer>
                </div>
                <div [class.col-lg-10]="filterbox" [class.col-lg-12]="!filterbox" >
                    <div class="card border-0 elevation-0">
                            <div class="row">
                                <div class="col-6">
                                    <div class="input-group input-group-sm p-1" >
                                        <input type="text" name="table_search" class="form-control float-right" placeholder="Cerca..." [(ngModel)]="filter_search.value" (keyup.enter)="getItems()" [class.alert-info]="filter_search.value!=''" [class.alert-info]="filter_search.value!=''">
                                        <div class="input-group-append ">
                                            <button type="submit" class="btn btn-default text-primary"  title="Avvia ricerca" (click)="getItems()"><i class="fas fa-search"></i></button>
                                            <button class="btn btn-default text-danger" *ngIf="filter_search.value!=''"  title="Annulla ricerca" (click)="filter_search.value='';getItems();"><span id="searchclear" class="fas fa-times"></span></button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6" *ngIf="mode!='modal'">
                                    <div class="pr-1">
                                        <app-windowlistbuttons 
                                        [model]="this" 
                                        [table]="'dossier'" 
                                        [funs]="[]"
                                        ></app-windowlistbuttons>
                                    </div>
                                </div>
                            </div> 
                            <form [formGroup]="form" >
                                <div class="text-responsive">
                                    <table class="table table-sm table-head-fixed table-striped m-0" >
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div #checkboxselectall class="icheck-primary d-inline">
                                                        <input type="checkbox" title="Seleziona tutti" (change)="onChangeAll($event.target.checked)"/>
                                                    </div>
                                                </th>
                                                <th></th>
                                                <th>
                                                    <span class="d-none d-lg-inline">Data
                                                        <button type="button" class="btn btn-tool" (click)="switchOrdering('d.created')"><i class="fas fa-sort {{classOrdering('d.created')}}"></i></button>
                                                    </span>
                                                </th>
                                                <th>
                                                    <span class="d-none d-lg-inline">Cod./Titolo
                                                        <button type="button" class="btn btn-tool" (click)="switchOrdering('d.code')"><i class="fas fa-sort {{classOrdering('d.code')}}"></i></button>
                                                    </span>
                                                </th>
                                                <th class="d-none d-lg-table-cell" [width]="140">
                                                    Cliente
                                                </th>
                                                <th><span class="d-none d-lg-inline">Tipologia</span></th>
                                                <th>Stato</th>
                                                <th class="d-none d-lg-table-cell text-center">Operatore</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody *ngIf="list && list.length>0">
                                        
                                            <!-- elemento ripetuto -->
                                            <tr *ngFor="let record of list" [class.bg-redline]="record.errors && record.errors.length>0">
                                                <td>
                                                    <input type="checkbox" #checkrecord id_record="{{record.id}}" title="ID: {{record.id}}"
                                                    (change)="onChange(record.id, $event.target.checked)" [checked]="checkedAll" />
                                                </td>
                                                <td>
                                                    <i *ngIf="listNotes(record.notes)!=''" [title]="listNotes(record.notes)" (dblclick)="markNotes(record.notes)" class="fa fa-exclamation-circle help" ></i>
                                                    <ng-container *ngFor="let e of record.errors">
                                                        <i [title]="e.message" class="fa fa-exclamation-triangle" [class.text-danger]="e.type=='danger'" [class.text-warning]="e.type=='warning'"></i>
                                                    </ng-container>
                                                </td>
                                                <td>{{record.created | date:"dd/MM/yyyy"}}</td>
                                                <td class="pointer" (click)="openDetail(record)" title="Modifica / Vedi">
                                                    <small class="d-none d-lg-inline text-gray">{{record.code}}</small><br>
                                                    <b>{{record.title}}</b>
                                                </td>                                               
                                                <td class="d-none d-lg-table-cell">
                                                    <ng-container *ngIf="record.addressItem">
                                                        <small><i class="fas fa-user text-gray mr-1"></i>{{record.addressItem.name}}</small>
                                                    </ng-container>
                                                </td>
                                                <td><small>{{record.type}}</small></td>
                                                <td>
                                                    <div style="line-height: 10pt;">
                                                        <ng-container *ngFor="let p of record.phasesstatus">
                                                            <span *ngIf="p.state==0 || p.state==null" class="fas fa-square-full text-gray help" title="{{getTitle(p)}}"></span>
                                                            <span *ngIf="p.state==1" class="fas fa-square-full text-warning help" title="{{getTitle(p)}}"></span>
                                                            <span *ngIf="p.state==2" class="fas fa-square-full text-primary help" title="{{getTitle(p)}}"></span>
                                                            <span *ngIf="p.state==3" class="fas fa-square-full text-danger help" title="{{getTitle(p)}}"></span>
                                                            <span *ngIf="p.state==4" class="fas fa-square-full text-success help" title="{{getTitle(p)}}"></span>
                                                            <!-- <span *ngIf="p.state==5" class="fas fa-square-full text-warning help" title="{{getTitle(p)}}"></span> -->
                                                            <!-- <span *ngIf="p.state==6" class="fas fa-square-full text-danger help" title="{{getTitle(p)}}"></span> -->
                                                        </ng-container>
                                                    </div>
                                                </td>
                                                <td class="d-none d-lg-table-cell text-center">
                                                    <div *ngIf="record.username" class="rounded-circle mx-auto d-flex align-items-center justify-content-center bg-purple text-uppercase help" style="height:2rem; width:2rem" title="{{record.username}} ">{{record.username[0]}}</div>
                                                </td>                                              
                                                <td>
                                                    <button type="button" *ngIf="mode!='modal'" (click)="exportInRow(record)" title="Stampa" class="btn btn-warning btn-xs float-right ">
                                                        <i class="fas fa-print"></i></button>                                                
                                                    <button type="button" *ngIf="mode!='modal'" (click)="openDetail(record)"  title="Modifica / Vedi" class="btn btn-secondary btn-xs float-right ">
                                                        <i class="fas fa-pencil-alt"></i></button>
                                                    <button type="button" *ngIf="mode=='modal'" class="btn btn-secondary btn-xs float-right ml-1" (click)="selectRecord(record)">
                                                        <span class="d-none d-sm-inline-block">Seleziona&ensp;</span><i class="fas fa-chevron-right"></i></button>
                                                    <button type="button" *ngIf="mode!='modal'"  (click)="notify(record)" title="Notifica" class="btn btn-primary btn-xs float-right ">
                                                        <i class="far fa-paper-plane"></i></button>
                                                    <button type="button" *ngIf="mode!='modal'" (click)="openPreview(record)" title="Anteprima" class="btn btn-info btn-xs float-right ">
                                                        <i class="far fa-eye"></i></button>                   
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </form>
                            <div class="card-footer clearfix py-1">
                                <app-pagination [model]="this" ></app-pagination>
                            </div>
                    </div>
                </div>
            </div>
        </app-windowlist>

    </div>
</div>